import React from 'react';

import { buttonStyle } from '../../../styles/constants';

/**
 * Props for the Button component
 */
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Function called when button is clicked */
  onClick: () => void;
  /** Whether the button is disabled */
  disabled?: boolean;
  /** Button label text or content */
  text: React.ReactNode;
}

/**
 * Standard Button Component
 *
 * A reusable button component with consistent styling across the application.
 * Uses the standard buttonStyle from the design system.
 *
 * @example
 * <Button
 *   text="Login"
 *   onClick={handleLogin}
 *   disabled={isLoading}
 * />
 */
export const Button: React.FC<ButtonProps> = ({ onClick, disabled, text, ...props }) => {
  return (
    <button style={buttonStyle} onClick={() => onClick()} disabled={disabled} {...props}>
      {text}
    </button>
  );
};

export default Button;
